import { FeedbackData, FeedbackType } from 'src/api/feedback';

import { FeedbackState } from './types';

export const emptyFeedbacks: FeedbackData[] = [];

export const feedbackFirstPageNumber = 1;

export const initialState: FeedbackState = {
  loading: false,
  feedbackType: FeedbackType.Issue,
  rows: emptyFeedbacks,
  pageNumber: feedbackFirstPageNumber,
  hasMore: true,
  currentRequestId: undefined,
  comment: '',
};
